import { makeAutoObservable, runInAction } from 'mobx';
import { rootContainer, TYPE } from '../../services/container/root';
import TroubleshootingService from '../../services/api/troubleshooting-service';
import {FONT_COLOR} from "../../components/fonts/font-props";
import {
    isNumber
} from "../policies/components/policy-editor/policy-eligibility-card/condition-group-card/condition-builder/helpers/type-convertions";

export interface IHealthDashboardStore {
	errorDistribution: any;
	errorRatio: any;
	selectedDays: number;
	fetchErrorDistribution: (isResolved?: boolean, days?: number) => void;
	fetchHealthStats: (days?: number) => void;
	setSelectedDays: (days: number) => void;
}

class HealthDashboardStore implements IHealthDashboardStore {
	errorDistribution: any = null;
	errorRatio: any = null;
	selectedDays: number = 7; // Default to 7 days

    timeFrameOptions = [
        { days: 1, label: 'Last Day' },
        { days: 7, label: 'Last 7 Days' },
        { days: 30, label: 'Last 30 Days' },
        { days: 365, label: 'Last 365 Days' }
    ];

	private get troubleshootingService(): TroubleshootingService {
		return rootContainer.get<TroubleshootingService>(TYPE.TroubleshootingService);
	}

	constructor() {
		makeAutoObservable(this);
	}

	async fetchErrorDistribution(isResolved?: boolean, days?: number) {
		const daysToUse = days || this.selectedDays;
		const errorDistribution = await this.troubleshootingService.getErrorDistribution(isResolved, daysToUse);
		runInAction(() => {
			this.errorDistribution = errorDistribution;
		});
	}

	async fetchHealthStats(days?: number) {
		try {
			const daysToUse = days || this.selectedDays;
			const healthStats = await this.troubleshootingService.getErrorRatio(daysToUse);
			runInAction(() => {
				this.errorRatio = healthStats;
			});
		} catch (error) {
			console.error("Error fetching health ratio:", error);
			runInAction(() => {
				this.errorRatio = null;
			});
		}
	}

	setSelectedDays(days: number) {
		runInAction(() => {
			this.selectedDays = days;
		});
	}

    // Determine icon color based on percentage thresholds
    getIconColor = (percentage?: number): string => {
        if (percentage === undefined) return `var(--${FONT_COLOR.NEUTRAL12})`; // Default gray

        return `var(--${this.getRatioColor(percentage)})`;
    };

    getRatioColor = (ratio: number): FONT_COLOR => {
        const percentage = isNumber(ratio) ? ratio * 100 : 0;
        if (percentage < 1) {
            return FONT_COLOR.SEMANTIC_SUCCESS; // Green for under 1%
        } else if (percentage >= 1 && percentage <= 30) {
            return FONT_COLOR.SEMANTIC_WARNING; // Orange for 1-30%
        } else {
            return FONT_COLOR.SEMANTIC_DANGER; // Red for over 30%
        }
    };
}

/** TODO: find a way to instantiate store by demand */
export default new HealthDashboardStore();
